import moment from 'moment'
import {FilterInitialStateModel} from './filterModel'

export const filterInitialState: FilterInitialStateModel = {
  applyFilter: null,
  FilterPersonInsurance: {
    fromDate: moment().subtract(12, 'months').startOf('month').format('YYYY/MM/DD'),
    toDate: moment().add(6,'months').endOf('month').format('YYYY/MM/DD'),
    branchCode: null,
    partnerCode: null,
    userCode: null,
    source: null,
    contractNo: null,
    certificatetNo: null,
    customerName: null,
    contractStatus: null,
    contractKind: null,
  },
  FilterApproval: {
    fromDate: moment().subtract(12, 'months').startOf('month').format('YYYY/MM/DD'),
    toDate: moment().add(6,'months').endOf('month').format('YYYY/MM/DD'),
    branchCode: null,
    partnerCode: null,
    userCode: null,
    contractNo: null,
    certificatetNo: null,
    customerName: null,
    contractStatus: null,
  },
  FilterCustomer: {
    customerType: null,
    customerSegment: null,
    customerSource: null,
    customerName: null,
    divisionCode: null,
    partnerCode: null,
    companyCode: null,
  },
  FilterPayment: {
    fromDate: moment().subtract(12, 'months').startOf('month').format('YYYY/MM/DD'),
    toDate: moment().add(6,'months').endOf('month').format('YYYY/MM/DD'),
    branchCode: null,
    partnerCode: null,
    certificatetNo: null,
    customerName: null,
    backlogType: '0',
    paymentType: '0',
  },
  FilterCertificate: {
    date: undefined,
    filter: null,
  },
  FilterRenew: {
    fromDate: moment().subtract(4, 'months').startOf('month').format('YYYY/MM/DD'),
    toDate: moment().add(3, 'years').endOf('month').format('YYYY/MM/DD'),
    branchCode: null,
    partnerCode: null,
    userCode: null,
    source: null,
    contractNo: null,
    certificatetNo: null,
    customerName: null,
    contractStatus: null,
  },
  FilterDashboard: {
    exploitingCode: null,
    division: null,
    customer: null,
  },
  RefreshDashboard: {
    refresh: null,
  },
}
